<template>
    <div class="obligations">
        <p class="pb-5">
            <strong class="has-text-primary" >Paso 1.</strong>
            <span v-if="!company.first_sync_completed">
                Conéctate con tu <strong>SII</strong> para tener automáticamente
                y en línea la información de tus ventas, compras, y boletas de
                honorarios.</span
            >
            <span v-else>
                <strong class="has-text-primary">Completado.</strong> Ya estás conectado al SII.
            </span>
        </p>
        <SiiDisconnect
            v-if="hasSIIAutomation && company.first_sync_completed !== 'SyncError'"
            @on-disconnect-sii="onDisconnectSii"
            :loading="disconnectIsLoading"
        />
        <SIIconnect
            v-else
            @on-connect-sii="onConnectSii"
            :widget-is-loading="widgetIsLoading"
            :is-waiting="company.first_sync_completed"
        />
        <p class="pb-4">
            <strong class="has-text-primary">Paso 2.</strong>
            <span>
                Ingresa manualmente y de forma recurrente otras obligaciones que aún no podemos mapear de forma automática.
            </span>
        </p>
        <AddObligations :has-sii-automation="hasSIIAutomation" class="mb-6" />
        <FilterObligations
            class="mb-5"
            :has-sii-automation="hasSIIAutomation"
        />
        <DownloadBar
            v-if="hasObligationsItems"
            class="mb-4"
            :download-doc="false"
            @on-send-email="onSendEmail"
            :total-items="numberRegisters"
            :available-documents="availableDocuments"
            :show-succesfull-msg="showSuccesfullMsg"
            data-description="filas de obligaciones"
        />
        <ListObligations v-if="isVisible"
            :has-sii-automation="hasSIIAutomation"
            :first-sync-completed="company.first_sync_completed"
        />
    </div>
</template>

<script>
import { sendEmail } from "@/api/exportDocuments";
import { getFintocToken, saveFintocUserHolder } from "@/api/fintoc";
import DownloadBar from "@/components/downloadBar/DownloadBar";
import SIIconnect from "@/components/SIIConnect/SIIconnect";
import { consoleHandlerError } from "@/utils/message";
import SegmentAnalytics from "@/utils/segmentAnalytics";
import { mapActions, mapMutations, mapState } from "vuex";
import AddObligations from "./AddObligations";
import FilterObligations from "./FilterObligations";
import ListObligations from "./listObligations/ListObligations";
import SiiDisconnect from "./SiiDisconnect";

import config from "@/config";

export default {
    name: "Obligations",
    components: {
        AddObligations,
        ListObligations,
        FilterObligations,
        SIIconnect,
        SiiDisconnect,
        DownloadBar,
    },
    props: {
        isVisible: Boolean,
    },
    data() {
        return {
            widget: () => {},
            showSuccesfullMsg: null,
            widgetIsLoading: false,
            disconnectIsLoading: false,
            hasObligationsItems: false,
            availableDocuments: [
                {
                    value: "allObligationsReport",
                    name: "Reporte de Obligaciones Totales",
                },
            ],
        };
    },
    computed: {
        ...mapState("userAuth", ["user", "company", "hasSIIAutomation"]),
        ...mapState("taxDocument", ["numberRegisters", "taxDocumentsList"]),
    },
    watch: {
        taxDocumentsList() {
            if (this.taxDocumentsList.length > 0) {
                this.hasObligationsItems = true;
            } else {
                this.hasObligationsItems = false;
            }
        },
    },
    methods: {
        ...mapMutations("userAuth", ["SET_SII_AUTOMATION"]),
        ...mapActions("userAuth", ["refreshSession"]),
        ...mapActions("fintoc", ["disconnectAccountLink"]),
        ...mapActions("taxDocument", ["getAllTaxDocuments"]),
        onConnectSii() {
            this.widgetIsLoading = true;
            getFintocToken({ product_type: "invoices" })
                .then((response) => {
                    this.widget = window.Fintoc.create({
                        holderType: "business",
                        product: "invoices",
                        publicKey: response.data.public_key,
                        webhookUrl: `${config.webhookAPI}/fintoc_app/link_token/?token=${response.data.webhook_token}`,
                        onExit: () => this.onWidgetExit(),
                        onSuccess: (link) =>
                            this.onWidgetSuccess(
                                response.data["company_product_link"]["id"],
                                link
                            ),
                    });
                    this.widget.open();
                    this.widgetIsLoading = false;
                })
                .catch(() => {});
        },
        async onWidgetSuccess(id, linkp) {
            linkp["company_product_link_id"] = id;
            await saveFintocUserHolder(linkp);

            await this.refreshSession();
            window.location.reload();
        },
        onWidgetExit() {
            this.widget.destroy();
        },
        onDisconnectSii() {
            this.disconnectIsLoading = true;
            this.disconnectAccountLink(this.company.company_product_link_sii)
                .catch((error) => {
                    consoleHandlerError({ error });
                })
                .finally(() => {
                    window.location.reload();
                });
        },
        onSendEmail(data) {
            new SegmentAnalytics().trackDownloadDocument({
                section: "obligations",
                name: data.name,
            });
            sendEmail(data)
                .then(() => {
                    this.showSuccesfullMsg = true;
                    setTimeout(() => {
                        this.showSuccesfullMsg = null;
                    }, 3000);
                })
                .catch((error) => {
                    this.showSuccesfullMsg = false;
                    consoleHandlerError({ error });
                });
        },
    },
};
</script>
